import React, { useMemo } from 'react';
import { Stack } from '@mui/material';
import { Button } from 'components/Button/Button';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { ConfirmationDialog } from 'components/ConfirmationDialog/ConfirmationDialog';
import { ConfirmationDialogState } from 'features/settings/types/types';
import { useDeleteAccount } from 'hooks/useDeleteAccount';
import { DeleteAccountConfirmInput } from './DeleteAccountConfirmInput';

export const DeleteAccount = () => {
  const { translation } = useTranslationContext();

  const { confirmDialogContent, handleDeleteClick, setEnableDelete, confirmationDialogState } =
    useDeleteAccount();

  const confirmationDialogContent = useMemo(() => {
    if (confirmationDialogState === ConfirmationDialogState.CONFIRM) {
      return (
        <Stack spacing={1} mt={2} className="delete-account__confirm-input-container">
          <DeleteAccountConfirmInput toggleDeleteEnabled={setEnableDelete} />
        </Stack>
      );
    }
    return null;
  }, [confirmationDialogState, setEnableDelete]);

  return (
    <>
      <Button
        id="delete-account-button"
        className="delete-account__button"
        variant="outlined"
        size="large"
        color="error"
        onClick={handleDeleteClick}
      >
        {translation('delete_account')}
      </Button>
      <ConfirmationDialog
        {...confirmDialogContent}
        id="delete-account-dialog"
        className="delete-account__dialog"
        dialogTitleProps={{
          sx: {
            lineHeight: 1.25,
            pt: 3,
          },
        }}
      >
        {confirmationDialogContent}
      </ConfirmationDialog>
    </>
  );
};
